import { Group, MultiSelect, Stack } from '@forwardflow/ui-v2'
import { SearchMagnifyingGlassIcon, UserAddIcon } from '@forwardflow/icons'
import { TFubUser } from '@forwardflow/types/onboarding'
import { TeamMemberCard } from './TeamMemberCard'

interface TeamMemberInvitationProps {
   invitedTeamMembers: TFubUser[]
   maxTeamMembers: number
   shouldDisableInvite: boolean
   isOnboardingCompleted: boolean
   userData: Array<{ value: string; label: string }>
   onInviteUser: (userIds: string[]) => void
   onRemoveUser: (userId: string) => void
}

export const TeamMemberInvitation = ({
   invitedTeamMembers,
   maxTeamMembers,
   shouldDisableInvite,
   isOnboardingCompleted,
   userData,
   onInviteUser,
   onRemoveUser,
}: TeamMemberInvitationProps) => {
   if (maxTeamMembers <= 0) {
      return null
   }

   const selectedIds = invitedTeamMembers.map((m) => String(m.id))

   return (
      <Stack gap={4}>
         <Stack gap={4}>
            <Group justify="space-between">
               <p className="text-white/90 text-sm font-medium">
                  Invite Team Members
               </p>
               <p className="text-[#99A1AF] text-sm font-medium">
                  {invitedTeamMembers?.length} / {maxTeamMembers}
               </p>
            </Group>
            <MultiSelect
               leftSection={
                  <SearchMagnifyingGlassIcon color="#99A1AF" width={14} />
               }
               disabled={shouldDisableInvite || isOnboardingCompleted}
               searchable
               placeholder={
                  shouldDisableInvite
                     ? 'You have reached the maximum number of team members'
                     : 'Search for your Team members'
               }
               value={selectedIds}
               onChange={onInviteUser}
               data={userData || []}
               maxValues={maxTeamMembers}
               hidePickedOptions
               classNames={{ pill: '!hidden' }}
            />
         </Stack>

         {invitedTeamMembers && invitedTeamMembers?.length > 0 && (
            <Stack className="mt-2">
               <p className="text-white/90 font-medium flex items-center gap-2">
                  <UserAddIcon width={24} color="#A684FF" /> Added Team Members
                  ({invitedTeamMembers?.length})
               </p>
               <Stack>
                  {invitedTeamMembers?.map((user) => (
                     <TeamMemberCard
                        key={user.id}
                        user={user}
                        onRemove={onRemoveUser}
                        isReadOnly={isOnboardingCompleted}
                     />
                  ))}
               </Stack>
            </Stack>
         )}
      </Stack>
   )
}
